// Shapes the value of the `context` object being passed into the HapYak player.
const shapeContextValue = (user, videoId, showVeil) => {
  const isStudent = user?.student;
  const isParent = user?.parent;

  return {
    user: {
      uid: user.id,
      permissions: {
        showCorrectAnswers: !(isStudent || isParent),
        quizReadOnly: !isStudent,
        showVeil,
      },
    },
    content: {
      cid: videoId,
    },
  };
};

export default shapeContextValue;
